export default class StickySection {


	// Constructor
	constructor(asscroll, element, contentSelector) {
		this.asscroll = asscroll;
		this.element = element;
		this.content = this.element.querySelector(contentSelector);
		this.scroll = this.scroll.bind(this);
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.content;
		delete this.element;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	scroll() {
		const { top } = this.element.getBoundingClientRect();
		const elementHeight = this.element.offsetHeight;
		const windowHeight = window.innerHeight;
		const y = -top + windowHeight;
		const height = windowHeight + elementHeight;
		const percent = Math.min(1, Math.max(0, y / height));
		this.content.style.transform = `translate3d(0, ${(1 - percent) * -16}%, 0)`; // parallax image is 20% taller than its container element
	}


}
